import React from 'react'

export interface SpecSectionTitleProps {
  title?: React.ReactNode
}

export const SpecSectionTitle: React.FC<SpecSectionTitleProps> = ({
  title,
}) => {
  return <div className="divider is-left m-0 mb-2 mt-2">{title}</div>
}
